import React, { Component } from 'react';
import Popup from '../../components/popup/Popup';
import Card from '../../components/card/Card';
import Label from '../../components/label/Label';
import UniversalDropDown from '../../components/universalDropDown/UniversalDropDown';
import PrimaryButton from '../../components/primaryButton/PrimaryButton';
import FontIcon from '../../components/fontIcon/FontIcon';
import mainAPI from '../../api/MainAPI';
import toasts from '../../utils/toasts';
import './TemperatureSensorPopup.css';
import bloodCooler from './2LBloodCooler.png';
import {addTempSensor, temperatureSensor, tempSensors} from "../../utils/tempSensorVerbage";
import userGroupSettingsManager from "../../utils/UserGroupSettingsManager";

export default class TemperatureSensorPopup extends Component {
	constructor(props) {
		super(props);
		this.state = {
			availableTempSensors: [],
			showTempSensorDropdown: false,
			selectedTempSensor: null
		};
	}

	_scanForTempSensors = async () => {
		const temperatureSensors = tempSensors(userGroupSettingsManager.getSetting('bloodcomm_uuid'));
		try {
			const response = await mainAPI.sensor.scan();
			
			this.setState({ 
				availableTempSensors: response.sensors,
				showTempSensorDropdown: true 
			});
			toasts.show(temperatureSensors + ' scanned successfully');
		} catch (error) {
			console.error('Error scanning for :' + temperatureSensors, error);
			toasts.show('Error scanning for ' + temperatureSensors);
		}
	};

	_onTempSensorSelect = (sensorId) => {
		const selectedSensor = this.state.availableTempSensors.find(s => s.id === sensorId);
		this.setState({ 
			selectedTempSensor: selectedSensor,
		});
	};

	_addTempSensorToBox = async () => {
		if (!this.state.selectedTempSensor) {
			toasts.show('Please select a temperature sensor first');
			return;
		}

		if (!this.props.drugBoxId) {
			toasts.show('Drug box ID is required');
			return;
		}

		try {
			// Add the temperature sensor to the drug box
			const result = await mainAPI.drug_box.update({
				id: this.props.drugBoxId,
				sensor_id: this.state.selectedTempSensor.id
			});

			if (result) {
				toasts.show('Temperature sensor added successfully');
				this.setState({ 
					selectedTempSensor: null,
					availableTempSensors: [],
					showTempSensorDropdown: false 
				});
				
				// Notify parent component that a sensor was added
				if (this.props.onSensorAdded) {
					this.props.onSensorAdded(this.state.selectedTempSensor);
				}
				
				// Close the popup
				this.props.onClose();
			} else {
				toasts.show('Failed to ' + addTempSensor(userGroupSettingsManager.getSetting('bloodcomm_uuid').toLowerCase()));
			}
		} catch (error) {
			const ts = temperatureSensor(userGroupSettingsManager.getSetting('bloodcomm_uuid'));
			console.error('Error adding temperature sensor:', error);
			toasts.show('Error adding ' + ts.toLowerCase());
		}
	};

	render() {
		let show = this.props.show;
		if (!this.props.hasOwnProperty('show')) {
			show = true;
		}
		const temperatureSensors = tempSensors(userGroupSettingsManager.getSetting('bloodcomm_uuid'));
		const ts = temperatureSensor(userGroupSettingsManager.getSetting('bloodcomm_uuid'));

		return (
			<Popup {...this.props} show={show} className="g-temperature-sensor-popup">
				<Card>
					<FontIcon className="close-icon" onClick={this.props.onClose} name="icon-close" />
					<Label large black center>
						{addTempSensor(userGroupSettingsManager.getSetting('bloodcomm_uuid'))}
					</Label>
					
					<div className="temp-sensor-content">
						<PrimaryButton
							center
							className="scan-temp-sensors"
							onClick={this._scanForTempSensors}
						>
							Search
						</PrimaryButton>
						
						{this.state.showTempSensorDropdown && (
							<div className="temp-sensor-dropdown">
								<Label black bold>Available {temperatureSensors}:</Label>
								<UniversalDropDown 
									options={this.state.availableTempSensors}
									placeholder={"Select a " + ts.toLowerCase()}
									onChange={this._onTempSensorSelect}
									onRenderOption={(display) => {
										if(display && display.toLowerCase().includes('ice-002l')){
											return <><img className={'blood-cooler'} src={bloodCooler} alt={'blood-cooler'}/> {display.replace('ICE-002L', ' ')}</>
										}
									}}
								/>
								{this.state.selectedTempSensor && (
									<PrimaryButton
										className="add-temp-sensor" 
										color="white" 
										bg="blue" 
										onClick={this._addTempSensorToBox}
									>
										Save
									</PrimaryButton>
								)}
							</div>
						)}
					</div>
				</Card>
			</Popup>
		);
	}
}



// WEBPACK FOOTER //
// ./src/popups/temperatureSensorPopup/TemperatureSensorPopup.jsx